<template>
  <div class="wrapper-materials">
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Joomla! Boilerplate</h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col md="4" lg="3">
          <img class="w-100" src="/images/icon/icon-updates--primary.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p><strong>The jump start for the development of an individual Joomla template.</strong> Create your own Joomla! template based on our Boilerplate.</p>
          <h4>ZIP-Archive</h4>
          <ul class="documentlist">
            <li class="zip"><a href="/docs/toolbox/assets/backupmonkey-boilerplate-3X.zip">Joomla! 3.X Boilerplate [ZIP]</a></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Maintenance Service Presentation Template</h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col md="4" lg="3">
          <img class="w-100" src="/images/icon/icon_presentation.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>The kickstart for the presentation of your maintenance service. <strong>Simply adapt our PowerPoint or PDF templates</strong> to your service and convince your customers with powerful arguments. </p>
          <h4>PPTX</h4>
          <ul class="documentlist">
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/ENG/PPTX/Presentation_MaintenanceContract_BackupMonkey_16x9_ENG.pptx">Presentation Maintenance Contract, 16x9 [ENG]</a></li>
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/ENG/PPTX/Presentation_MaintenanceContract_BackupMonkey_9x16_ENG.pptx">Presentation Maintenance Contract, 9x16 [ENG]</a></li>
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/ENG/PPTX/Presentation_MaintenanceContract_BackupMonkey_A4_ENG.pptx">Presentation Maintenance Contract, DIN A4 [ENG]</a></li>
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/DE/PPTX/Vorstellung_Wartungsvertrag_BackupMonkey_16x9_DE.pptx">Presentation Maintenance Contract, 16x9 [DE]</a></li>
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/DE/PPTX/Vorstellung_Wartungsvertrag_BackupMonkey_9x16_DE.pptx">Presentation Maintenance Contract, 9x16 [DE]</a></li>
            <li class="pptx"><a href="/docs/toolbox/presentation-maintenance/DE/PPTX/Vorstellung_Wartungsvertrag_BackupMonkey_A4_DE.pptx">Presentation Maintenance Contract, DIN A4 [DE]</a></li>
          </ul>
          <h4>PDF</h4>
          <ul class="documentlist">
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/ENG/PDF/Presentation_MaintenanceContract_BackupMonkey_16x9_ENG.pdf">Presentation Maintenance Contract, 16x9 [ENG]</a></li>
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/ENG/PDF/Presentation_MaintenanceContract_BackupMonkey_9x16_ENG.pdf">Presentation Maintenance Contract, 9x16 [ENG]</a></li>
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/ENG/PDF/Presentation_MaintenanceContract_BackupMonkey_A4_ENG.pdf">Presentation Maintenance Contract, DIN A4 [ENG]</a></li>
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/DE/PDF/Vorstellung_Wartungsvertrag_BackupMonkey_16x9_DE.pdf">Presentation Maintenance Contract, 16x9 [DE]</a></li>
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/DE/PDF/Vorstellung_Wartungsvertrag_BackupMonkey_9x16_DE.pdf">Presentation Maintenance Contract, 9x16 [DE]</a></li>
            <li class="pdf"><a href="/docs/toolbox/presentation-maintenance/DE/PDF/Vorstellung_Wartungsvertrag_BackupMonkey_A4_DE.pdf">Presentation Maintenance Contract, DIN A4 [DE]</a></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Joomla! Launch Checklist</h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col md="4" lg="3">
          <img class="w-100" src="/images/icon/icon_checkbox.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>A new customer site is finished and after all the work finally ready for the live-action. <strong>Do the final launch check with our checklist.</strong></p>
          <h4>PDF</h4>
          <ul class="documentlist">
            <li class="pdf"><a href="/docs/toolbox/launch-checklist/launch-checkliste_ENG.pdf">Joomla! Launch Checklist [ENG]</a></li>
            <li class="pdf"><a href="/docs/toolbox/launch-checklist/launch-checkliste_DE.pdf">Joomla! Launch Checklist [DE]</a></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Pricing guide for maintenance contracts</h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col md="4" lg="3">
          <img class="w-100" src="/images/icon/icon_checkbox.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>Calculating prices for a maintenance contract can be difficult at the beginning.
            With our little guide we want to support you in this task.</p>
          <h4>PDF</h4>
          <ul class="documentlist">
            <li class="pdf"><a href="/docs/toolbox/calculating/backupmonkey_calculator_en.pdf">Pricing Guide [ENG]</a></li>
            <li class="pdf"><a href="/docs/toolbox/calculating/backupmonkey_calculator_de.pdf">Pricing Guide [DE]</a></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>What's missing?</h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col md="4" lg="3">
          <img class="w-100" src="/images/icon/icon_ape.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>We wish to offer our customers a comprehensive all in one eco-system, which simplifies the way to your own lucrative maintenance business. Therefore we are always open for wishes and feedback regarding future features, tools and tutorials for our customers.</p>
          <p><a href="mailto:lj@backupmonkey.io">Just drop us a line if you have a wish!</a></p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Materials'
}
</script>
